<template>
  <Form :data-detail="dataDetail" />
</template>

<script>
import { ref } from '@vue/composition-api'
import Form from '@/views/b/ruangan/components/Form.vue'
import helper from '@/libs/helper'

export default {
  setup(props, context) {
    const g = context.root

    const cookiesJenisAkun = g.$cookies.get('jenisAkun')

    const defaultKolok = ref(null)
    if (['A', 'D', 'F'].includes(cookiesJenisAkun)) {
      const cookiesKolok = g.$cookies.get('kolok')

      defaultKolok.value = cookiesKolok
    }

    const dataDetail = ref({
      kolok: defaultKolok.value,
      register: '',
      lantai: [
        {
          value: null,
          ruangan: [
            {
              kode: helper.defaultValue,
              nama: '',
            },
          ],
        },
      ],
    })
    return { dataDetail }
  },
  components: {
    Form,
  },
}
</script>
